export const Url = {
  baseUrl: 'https://mn90lw2fhc.execute-api.ap-south-1.amazonaws.com/Prod/',
  privacyPolicy: 'https://www.dreeshomes.com/privacy/',
  termsOfUse: 'https://www.dreeshomes.com/terms/',
  femPortal: 'https://idp.elliemae.com/authorize?client_id=srtrz0d2&site_id=9141421924&response_type=code&redirect_uri=https%3A%2F%2Fwww.firstequityonline.com%2Fborrower-app%2Flogin%2F%3FsiteId%3D9141421924&scope=ccbp%20cc&instance_id=be11177919&logo_url=https%3A%2F%2Fasset-service-bucket-prod.s3.us-west-2.amazonaws.com%2F1d42c3b5-f6dc-4a81-8fec-48860a404909&logo_alt_text=Logo&bust=16&apiBaseUrl=https://api.elliemae.com',
  paymentPortal: 'https://53.billerdirectexpress.com/ebpp/DreesHomesQP/',
  baseLocationUrl: 'https://www.dreeshomes.com/custom-homes',
  homeSummaryURL: 'Prod/homesummary',
  signoutHomePage: 'https://www.dreeshomes.com/',
  localBaseUrl: location.origin
}

export const footerNavigationUrl = {
  facebook: 'https://www.facebook.com/DreesHomes/ ',
  pinterest: 'https://www.pinterest.com/dreeshomes/',
  instagram: 'https://www.instagram.com/dreeshomes/',
  twitter: 'https://twitter.com/DreesHomes/',
  youtube: 'https://www.youtube.com/user/dreescustomhomes',
  linkedin: 'https://www.linkedin.com/company/drees-homes/'
}
